/**
 *
 * EnRouteTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import PinTripIcon from 'assets/v2/PinTripIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.rustDark};
    background: ${COLORS.rustLight};
    border-color: ${COLORS.rust};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.rust};
    }
  }
`;

function EnRouteTag(props) {
  return <StyledTag label="En Route" icon={<PinTripIcon />} {...props} />;
}

export default memo(EnRouteTag);
